export default "__VITE_ASSET__Bt1he_y0__"